const rooms = [
  {
    id: 'king',
    name: 'King Suite',
    background: require('../../../assets/images/king/king_0.jpeg'),
    title: 'King Suite',
    subtitle: 'King Suite',
    gallery: [
      require('../../../assets/images/king/king_0.jpeg'),
      require('../../../assets/images/king/king_1.jpeg'),
      require('../../../assets/images/king/king_2.jpeg'),
      require('../../../assets/images/king/king_3.jpeg'),
      require('../../../assets/images/king/king_4.jpeg'),
      require('../../../assets/images/king/king_5.jpeg'),
    ],
  },
  {
    id: 'deluxe',
    name: 'Deluxe Suite',
    background: require('../../../assets/images/deluxe/deluxe_0.jpeg'),
    title: 'Deluxe Suite',
    subtitle: 'Deluxe Suite',
    gallery: [
      require('../../../assets/images/deluxe/deluxe_0.jpeg'),
      require('../../../assets/images/deluxe/deluxe_1.jpeg'),
      require('../../../assets/images/deluxe/deluxe_2.jpeg'),
      require('../../../assets/images/deluxe/deluxe_3.jpeg'),
      require('../../../assets/images/deluxe/deluxe_4.jpeg'),
      require('../../../assets/images/deluxe/deluxe_5.jpeg'),
    ],
  },
  {
    id: 'superior',
    name: 'Superior Suite',
    background: require('../../../assets/images/superior/superior_1.jpeg'),
    title: 'Superior Suite',
    subtitle: 'Superior Suite',
    gallery: [
      require('../../../assets/images/superior/superior_0.jpeg'),
      require('../../../assets/images/superior/superior_1.jpeg'),
      require('../../../assets/images/superior/superior_2.jpeg'),
      require('../../../assets/images/superior/superior_3.jpeg'),
      require('../../../assets/images/superior/superior_4.jpeg'),
      require('../../../assets/images/superior/superior_5.jpeg'),
    ],
  },
];

export default rooms;